<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>THE WITNESS</span></p>
<p class="part-left1"><i>I only am escaped alone to tell thee</i> …</p>
<p class="part-left2"><i>My thought</i></p>
<p class="part-left2"><i>Darkened as by wind the water …</i></p>
<p class="part-left1"><i>There’s always</i></p>
<p class="part-left2"><i>Someone has to tell them, isn’t there?…</i></p>
<p class="part-left2"><i>Someone chosen by the chance of seeing</i>,</p>
<p class="part-left2"><i>By the accident of sight</i>,</p>
<p class="part-left2"><i>By the stumbling on the moment of it</i>,</p>
<p class="part-left2"><i>Unprepared, unwarned, unready</i>,</p>
<p class="part-left2"><i>Thinking of nothing … and it happens, and he sees it</i>.</p>
<p class="part-left2"><i>Caught in that inextricable net</i></p>
<p class="part-left2"><i>Of having witnessed, having seen …</i></p>
<p class="part-left1"><i>It was I</i>.</p>
<p class="part-left2"><i>I only. I alone. The moment</i></p>
<p class="part-left2"><i>Closed us together in its gaping grin</i></p>
<p class="part-left2"><i>Of horrible incredulity</i>.</p>
<p class="part-left2"><i>I only. I alone, to tell thee …</i></p>
<p class="part-left2"><i>I who have understood nothing, have known</i></p>
<p class="part-left2"><i>Nothing, have been answered nothing</i>.</p>
<p class="part-left2d">—Archibald MacLeish, <i>J.B</i>.</p>
<p class="part-left1"><i>God always wins</i>.</p>
<p class="part-left2d">—Archibald MacLeish, J.B.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part03.vue?199490ee